import request from '@/utils/request';
var baseURL = process.env.VUE_APP_OKEY_SERVER_API;
export function getUnreadMsgSize(data) {
  return request({
    url: baseURL + '/msg/getMsgTotal',
    method: 'post',
    data: data
  });
}